import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-graphite-950 text-white flex flex-col items-center justify-center gap-6 px-6">
      <div className="overline">Errore 404</div>
      <h1 className="text-6xl md:text-8xl font-display font-semibold tracking-tighter">Pagina non trovata</h1>
      <p className="text-white/60 max-w-md text-center">
        La pagina che stai cercando non esiste o è stata spostata.
      </p>
      <Link data-testid="notfound-home-link" to="/" className="btn-gold">
        Torna alla home
      </Link>
    </div>
  );
}
